/**
 * Constants for bed environment charts
 */
import i18n from '../../i18n';

export const BED_METRICS = [
  { key: 'moisturePct', color: '#1677ff', unit: '%', unitKey: null },
  { key: 'soilTempC', color: '#f5222d', unit: '°C', unitKey: null },
  { key: 'pH', color: '#52c41a', unit: '', unitKey: null },
  { key: 'nitrogen', color: '#389e0d', unit: '', unitKey: 'mgPerKg' },
  { key: 'phosphorus', color: '#fa8c16', unit: '', unitKey: 'mgPerKg' },
  { key: 'potassium', color: '#722ed1', unit: '', unitKey: 'mgPerKg' },
] as const;

export type BedMetricKey = typeof BED_METRICS[number]['key'];

export const FIELD_METRICS = [
  { key: 'snowDepthCm', color: '#91caff', unit: '', unitKey: 'cm' },
  { key: 'frostDepthCm', color: '#69b1ff', unit: '', unitKey: 'cm' },
  { key: 'cumulativeGDD', color: '#f5222d', unit: '', unitKey: 'degreeDays' },
] as const;

type MetricDef = { key: string; unit: string; unitKey: string | null };

/** Localized metric name, resolved at render time. */
export const metricLabel = (key: string): string => i18n.t(`beds:metrics.${key}`);

/** Localized metric unit, resolved at render time. */
export const metricUnit = (metric: MetricDef): string =>
  metric.unitKey ? i18n.t(`beds:units.${metric.unitKey}`) : metric.unit;

export type FieldMetricKey = typeof FIELD_METRICS[number]['key'];

export const BED_TIMESERIES_PROPERTIES = BED_METRICS.map(m => m.key);
